import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'as',
    fullName: 'Assamese',
    nativeName: 'অসমীয়া',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "কিবা এটা আচৰিত আহি আছে",
    landing_subtitle: "ArgVoid হৈছে এটা এপ আৰু গেম ডেভেলপমেণ্ট ষ্টুডিঅ'। লগত থাকক, নতুন নতুন কথা আহি আছে সোনকালে!",
    select_language: "ভাষা নিৰ্বাচন কৰক",
    search_placeholder: "ভাষা অনুসন্ধান...",
    terms_title: "সেৱাৰ চৰ্তসমূহ",
    policy_title: "গোপনীয়তা নীতি",
    cookies_title: "কুকি নীতি",
    terms_content: `
        <strong>1. চৰ্তসমূহ গ্ৰহণ কৰা</strong><br>
        ArgVoid অভিগম কৰি, এই সেৱাৰ চৰ্তসমূহ গ্ৰহণ কৰা হয়। যদি এই চৰ্তসমূহৰ সৈতে সন্মত নহয়, সেৱা ব্যৱহাৰ কৰা উচিত নহয়।<br><br>

        <strong>2. প্লেটফৰ্মৰ ব্যৱহাৰ</strong><br>
        ArgVoid আৰু ইয়াৰ এপ্লিকেচনসমূহ তথ্যমূলক আৰু সৃষ্টিশীল উদ্দেশ্যৰ বাবে "যেনে আছে" প্ৰদান কৰা হৈছে। সেৱা কেৱল বৈধ উদ্দেশ্যৰ বাবে ব্যৱহাৰ কৰিব লাগিব।<br><br>

        <strong>3. নিষিদ্ধ আচৰণ</strong><br>
        চাইটৰ দুৰ্বলতাসমূহ শোষণ কৰা, স্পেমিং কৰা, বা আন্তঃগাঁথনিলৈ অকৰ্তৃত্বশীল অভিগমৰ চেষ্টা কৰা কঠোৰভাৱে নিষিদ্ধ।<br><br>

        <strong>4. অস্বীকাৰ</strong><br>
        প্লেটফৰ্ম আৰু সেৱাসমূহ যিকোনো সময়তে বিনা জাননীত পৰিৱৰ্তন কৰিব পাৰিব। সেৱাৰ আপটাইম বা উপলব্ধতাৰ সন্দৰ্ভত কোনো ৱাৰেণ্টী প্ৰদান কৰা হোৱা নাই।
    `,
    policy_content: `
        <strong>1. তথ্য সংগ্ৰহ</strong><br>
        এই সময়ত প্লেটফৰ্মত ব্যৱহাৰকাৰী প্ৰমাণীকৰণ বা একাউণ্ট সৃষ্টিৰ প্ৰয়োজন নাই। কোনো ব্যক্তিগত চিনাক্তকৰণ তথ্য (যেনে নাম বা ইমেইল ঠিকনা) দৰ্শকৰ পৰা সক্ৰিয়ভাৱে সংগ্ৰহ কৰা নহয়।<br><br>

        <strong>2. ব্যৱহাৰ Data</strong><br>
        ছাইটৰ ট্ৰেফিক বুজিবলৈ আৰু এপ্লিকেচনসমূহ উন্নত কৰিবলৈ মৌলিক, বেনামী বিশ্লেষণসমূহ সংগ্ৰহ কৰিব পাৰি। এই তথ্য ব্যক্তিগত ব্যৱহাৰকাৰী পৰিচয়ৰ সৈতে সংযুক্ত নহয়।<br><br>

        <strong>3. তৃতীয় পক্ষৰ সেৱাসমূহ</strong><br>
        তৃতীয়-পক্ষ প্ৰদানকাৰীসকলক হ'ষ্টিং আৰু বিশ্লেষণ সেৱাসমূহৰ বাবে ব্যৱহাৰ কৰিব পাৰি। এই নিজ নিজ প্ৰদানকাৰীৰ গোপনীয়তা পদ্ধতিয়ে তেওঁলোকৰ আন্তঃগাঁথনিত প্ৰক্ৰিয়াকৃত বেনামী তথ্য নিয়ন্ত্ৰণ কৰে।<br><br>

        <strong>4. ডাটা সুৰক্ষা</strong><br>
        প্লেটফৰ্মক সুৰক্ষিত কৰাৰ বাবে যুক্তিসংগত সুৰক্ষা ব্যৱস্থা ৰূপায়ণ কৰা হয়। কিন্তু ইণ্টাৰনেটৰ জৰিয়তে সংক্ৰমণৰ কোনো পদ্ধতি সম্পূৰ্ণৰূপে সুৰক্ষিত নহয়।<br><br>
    `,
    cookies_content: `
        <strong>1. কুকীজ আৰু স্থানীয় সংৰক্ষণ কি?</strong><br>
        কুকীজ আৰু ব্ৰাউজাৰ স্থানীয় সংৰক্ষণ হৈছে ভিজিটসমূহৰ মাজেৰে বিন্যাস পছন্দসমূহ মনত ৰাখিবলৈ ডিভাইচত সংৰক্ষণ কৰা সৰু ডাটা ফাইলসমূহ

        <strong>2. ব্যৱহাৰৰ উদ্দেশ্য</strong><br>
        ব্ৰাউজাৰ LocalStorage ক বিন্যাস সংহতিসমূহ সংৰক্ষণ কৰিবলে কঠোৰভাৱে ব্যৱহাৰ কৰা হয়, যেনে:<br>
        - ভাষা পছন্দসমূহ<br>
        - ব্যৱহাৰকাৰী আন্তঃপৃষ্ঠ বিন্যাস (যেনে, বিন্যাস বা থিম সংহতিসমূহ)<br>
        - অস্থায়ী এপ্লিকেচন cache<br><br>

        <strong>3. কোনো ট্ৰেকিং</strong><br> নাই
        কুকীজ আৰু স্থানীয় সংৰক্ষণ বিজ্ঞাপন বা তৃতীয় পক্ষৰ অনুসৰণৰ উদ্দেশ্যে ব্যৱহাৰ কৰা নহয়। সকলো সংৰক্ষিত তথ্য কঠোৰভাৱে প্লেটফৰ্মৰ মূল কাৰ্য্যকৰীতাৰ বাবে।<br><br>

        <strong>4. নিয়ন্ত্ৰণ</strong><br>
        ব্ৰাউজাৰ ডাটা ব্ৰাউজাৰ ছেটিংছৰ জৰিয়তে যিকোনো সময়তে ক্লিয়াৰ কৰিব পাৰি, যিয়ে যিকোনো স্থানীয় কনফিগাৰেচন পুনৰায় সেট কৰিব।
    `,
    cookie_consent_text: "ৱেবছাইটটোৱে সঠিকভাৱে কাম কৰাটো নিশ্চিত কৰিবলৈ আমি মৌলিক কুকীজ ব্যৱহাৰ কৰো, যেনে আপোনাৰ অধিবেশন সক্ৰিয় ৰখা, আপোনাৰ ভাষাৰ পছন্দ সংৰক্ষণ কৰা, আৰু অন্যান্য স্বনিৰ্বাচিত সংৰূপসমূহ৷",
    read_policy: "কুকি নীতি পঢ়ক",
    support_title: "সমৰ্থনৰ সৈতে যোগাযোগ কৰক",
    support_subject_label: "বিষয়",
    support_message_label: "বাৰ্তা",
    support_submit_button: "বাৰ্তা প্ৰেৰণ কৰক",
    support_hint: "টোকা: ই আপোনাৰ অবিকল্পিত ইমেইল এপ্লিকেচন খোলিব বাৰ্তা প্ৰেৰণ কৰিবলে।",
    support_success_msg: "আপনার ইমেইল অ্যাপ্লিকেশন খোলা...",
    support_error_msg: "বাৰ্তা প্ৰেৰণ কৰাত ব্যৰ্থ। অনুগ্ৰহ কৰি পিছত পুনৰ চেষ্টা কৰক।",
    explorer_title: "এক্সপ্লোৰাৰ",
    history_title: "ইতিহাস",
    animation_title: "এনিমেচন",
    config_title: "বিন্যাস",
    tool_mouse: "(Ctrl+M) নিৰ্বাচন কৰক",
    tool_brush: "ব্ৰাছ (Ctrl+B)",
    tool_brush_mode: "টগল মোড (কঠিন/স্পষ্ট)",
    tool_eraser: "ইৰেজাৰ (Ctrl+E)",
    tool_brush_size: "ব্ৰাছৰ আকাৰ সামঞ্জস্য কৰক",
    tool_bucket: "পূৰণ কৰক (Ctrl+F)",
    tool_eyedropper: "চকুৰ ড্ৰপাৰ",
    tool_grid: "গ্ৰীড (Ctrl+Shift+B)",
    tool_rotate: "ঘূৰাওক (Ctrl+Shift+R)",
    tool_flip_h: "ফ্লিপ H (Ctrl+Shift+H)",
    tool_flip_v: "ফ্লিপ V (Ctrl+Shift+V)",
    tool_transpose: "ট্ৰেন্সপ'জ (Ctrl+Shift+T)",
    label_width: "প্ৰস্থ",
    label_height: "উচ্চতা",
    label_frames: "ফ্ৰেমৰ সংখ্যা",
    label_animation: "এনিমেচন শৈলী",
    label_background_color: "পটভূমিৰ ৰং",
    label_interval: "ব্যৱধান",
    tool_anim_config: "এনিমেচন বিন্যাস",
    label_new_width: "নতুন প্ৰস্থ",
    label_new_height: "নিউ হাইট",
    label_apply: "প্ৰয়োগ কৰক",
    label_colors: "ৰংবোৰ",
    label_size: "আকাৰ",
    label_tolerance: "সহনশীলতা",
    val_horizontal: "অনুভূমিক",
    val_vertical: "উলম্ব",
    val_sequence: "ক্ৰম",
    val_bounce: "জঁপিওৱা",
    val_random: "যাদৃচ্ছিক",
    val_solid: "গোটা",
    val_clear: "পৰিষ্কাৰ",
    action_add_sheet: "নতুন শ্বীট",
    action_import: "আমদানি",
    action_export: "ৰপ্তানি",
    action_sort_projects: "সজোৱা",
    sort_date_old: "আটাইতকৈ পুৰণি প্ৰথম",
    sort_date_new: "নতুন প্ৰথম",
    sort_name_az: "নাম (A-Z)",
    sort_name_za: "নাম (Z-A)",
    action_new_sprite: "নিউ স্প্ৰাইট",
    action_new_project: "নতুন প্ৰকল্প",
    modal_save_all_title: "সকলো পৰিবৰ্তন সংৰক্ষণ কৰক",
    modal_save_all_desc: "সংৰক্ষণ কৰিবলৈ সম্পত্তিসমূহ নিৰ্ব্বাচন কৰক:",
    modal_save_selected: "নিৰ্বাচিত সংৰক্ষণ কৰক",
    action_saved: "সংৰক্ষণ কৰা হৈছে",
    modal_create_sprite_title: "নতুন স্প্ৰাইট সৃষ্টি কৰক",
    modal_create_project_title: "নতুন প্ৰকল্প সৃষ্টি কৰক",
    modal_add_sheet_title: "নতুন শ্বীট যোগ কৰক",
    modal_rename_sheet_title: "শ্বীটৰ নাম সলনি কৰক",
    modal_rename_sprite_title: "স্প্ৰাইটৰ নাম সলনি কৰক",
    modal_delete_sprite_title: "Sprite মচি পেলাওক",
    modal_delete_project_title: "প্ৰকল্প মচি পেলাওক",
    modal_delete_sheet_title: "শ্বীট মচি পেলাওক",
    placeholder_sprite_name: "নাম",
    placeholder_project_name: "নাম",
    placeholder_sheet_name: "নাম",
    placeholder_new_name: "নতুন নাম",
    action_create: "সৃষ্টি কৰা",
    action_add: "যোগ কৰা",
    action_rename: "পুনৰ নামকৰণ কৰক",
    action_duplicate: "ডুপ্লিকেট কৰক",
    action_delete: "বিলোপ",
    action_cancel: "বাতিল কৰক",
    confirm_delete_sprite: "আপুনি নিশ্চিত নেকি যে আপুনি এই স্প্ৰাইটটো মচি পেলাব বিচাৰে?",
    confirm_delete_project: "আপুনি নিশ্চিত নেকি যে আপুনি এই প্ৰকল্পটো মচি পেলাব বিচাৰে? সকলো স্প্ৰাইট আঁতৰোৱা হ'ব।",
    confirm_delete_sheet: "আপুনি নিশ্চিত নেকি যে আপুনি এই পত্ৰিকাখন মচি পেলাব বিচাৰে?",
    err_select_sprite: "অনুগ্ৰহ কৰি প্ৰথমে এটা স্প্ৰাইট নিৰ্বাচন কৰক।",
    err_select_project: "অনুগ্ৰহ কৰি প্ৰথমে এটা প্ৰকল্প বাছক।",
    err_name_empty: "নাম খালী হ’ব নোৱাৰে।",
    err_sprite_exists: "সেই নামৰ এটা স্প্ৰাইট ইতিমধ্যে আছে।",
    err_project_exists: "সেই নামৰ এটা প্ৰজেক্ট ইতিমধ্যে আছে।",
    err_no_content: "সংৰক্ষণ কৰিবলৈ কোনো বিষয়বস্তু নাই।",
    err_no_changes: "সংৰক্ষণ কৰিবলৈ কোনো পৰিৱৰ্তন নাই।",
    err_delete_last_sheet: "শেষৰ শ্বীটখন মচি পেলাব নোৱাৰি।",
    err_extract_frames: "কোনো ফ্ৰেম উলিয়াব পৰা নগ'ল।",
    err_indexeddb: "স্থানীয়ভাৱে সংৰক্ষণ কৰাত ব্যৰ্থ। আপোনাৰ ব্ৰাউজাৰে IndexedDB সমৰ্থন নকৰিবও পাৰে।",
    msg_upload_success: "আপলোড সফল: {0}",
    msg_upload_failed: "আপলোড ব্যৰ্থ: {0}",
    msg_save_success: "সফল সঞ্চয় কৰক।",
    msg_saving: "সঞ্চয়...",
    msg_multi_save_result: "সংৰক্ষিত {0} সম্পত্তি। {১} বিফলতা।",
    menu_title: "মেনু",
    menu_save: "সঞ্চয় কৰা",
    menu_save_all: "সকলো সংৰক্ষণ কৰক",
    menu_support: "সমৰ্থনৰ সৈতে যোগাযোগ কৰক",
    label_local_storage: "স্থানীয় সংৰক্ষণ",
    label_sign_in: "চাইন ইন কৰক",
    modal_export_title: "Sprite ৰপ্তানি কৰক",
    label_filename: "ফাইলৰ নাম",
    label_format: "বিন্যাস",
    action_export_confirm: "ৰপ্তানি",
};

export default translations;
